// extracted by mini-css-extract-plugin
export default {"root":"Search_root__oDy4A","input":"Search_input__2Shxl","icon":"Search_icon__V+BEQ","clearIcon":"Search_clearIcon__xrcnF"};